import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataType3Preguntas } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataType3Preguntas,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    let consult = `Interpreta las tres tiradas de cartas que realizaste para ${
        data.consultante.name
    } que necesita saber en la primer tirada: ${data.consulta1}, en esta tirada salieron las siguientes cartas: ${formatCardLabel(cards[0])}, ${formatCardLabel(cards[1])}, ${formatCardLabel(cards[2])}, ${formatCardLabel(cards[3])} y ${formatCardLabel(cards[4])}; para la siguiente tirada la consulta es: ${data.consulta2} y las cartas que salieron son: ${formatCardLabel(cards[5])}, ${formatCardLabel(cards[6])}, ${formatCardLabel(cards[7])}, ${formatCardLabel(cards[8])} y ${formatCardLabel(cards[9])}; y por último, para la tercer tirada, la consulta es: ${data.consulta3} y las cartas que salieron son: ${formatCardLabel(cards[10])}, ${formatCardLabel(cards[11])}, ${formatCardLabel(cards[12])}, ${formatCardLabel(cards[13])} y ${formatCardLabel(cards[14])}. Decide tú como tarotista experta que eres, cual es el mejor tipo de lectura que puedes hacer para estas tres tiradas de cartas en base a lo que el consultante necesita saber en cada una de ellas. Puedes realizar combinaciones de cartas y tener en cuenta las influencias de las cartas, unas sobre otras. Ten en cuenta el signo zodiacal del consultante: ${
        data.consultante.zodiac
    }. No hagas una enumeración de las cartas, sino un desarrollo de cada una de las lecturas mencionandolas dentro del desarrollo. Dirígete directamente al consultante.`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer:
            'Consulta uno: ' +
            data.consulta1 +
            '. Consulta dos:  ' +
            data.consulta2 +
            '. Consulta tres: ' +
            data.consulta3,
        cards,
        type,
    }

    return info
}
